import { environment } from 'services/apiConfigs';

export default (size, folder, file_name) => {
  const amazon_default_cdn_url = 'https://d2jefos38oys06.cloudfront.net/fit-in';
  return `${amazon_default_cdn_url}/${size}/${environment}/${
    folder ? folder + '/' : ''
  }${file_name}`;
};



// WEBPACK FOOTER //
// ./src/app/services/amazonAWS/getFileOnS3.js